import React, { FunctionComponent } from 'react';
import { TextArea } from '../../atoms/textArea';
import { TextBox } from '../../atoms/textBox';

type Props = {
  title: string
  body: string
  textName: string
  bodyName: string
  isFocus: boolean
  onChangedTitle: (value: string) => void
  onChangedBody: (value: string) => void
};

export const Presentation: FunctionComponent<Props> = ({
  title,
  body,
  textName,
  bodyName,
  isFocus,
  onChangedTitle,
  onChangedBody
}) => {
  const handleTitleChange = (name: string, value: string) => {
    onChangedTitle(value)
  };

  const handleBodyChange = (name: string, value: string) => {
    onChangedBody(value)
  };


  return (
    <div className="message-template-inner-right">
      <TextBox
        className="message-template-inner-right-title jsx-template-title"
        placeholder="タイトルを入力してください"
        onChanged={handleTitleChange}
        name={textName}
        value={title}
        isFocus={isFocus}
        type="text"
      />
      <TextArea
        className="message-template-inner-right-body jsx-template-body"
        placeholder="本文を入力してください"
        onChanged={handleBodyChange}
        name={bodyName}
        value={body}
      />
    </div>
  );
};
